import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Popconfirm, Space } from 'antd';
import { Table, Button } from 'ui/styled';
import { DeleteOutlined } from '@ant-design/icons';
import { useContainerDimensions, getSecureTableHeight } from 'utils/hooks/useContainerDimensions';
import dayjs from 'dayjs';
import { HUMANIZE_FORMAT_12H } from 'utils/helpers/dateHelper';
import useTeamOrganizationGroupsTable from './hooks/useTeamOrganizationGroupsTable';
var OFFSET = 140;
var columns = function (onOrgDelete) { return [
    {
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
        render: function (_, item) { return item === null || item === void 0 ? void 0 : item.name; },
        width: '40%'
    },
    {
        title: 'Created at',
        key: 'created_at',
        dataIndex: 'created_at',
        render: function (_, item) {
            return dayjs(item === null || item === void 0 ? void 0 : item.created_at).format(HUMANIZE_FORMAT_12H);
        },
        width: '20%'
    },
    {
        title: 'Updated at',
        key: 'updated_at',
        dataIndex: 'updated_at',
        render: function (_, item) {
            return dayjs(item === null || item === void 0 ? void 0 : item.updated_at).format(HUMANIZE_FORMAT_12H);
        },
        width: '20%'
    },
    {
        title: 'Actions',
        key: 'actions',
        render: function (_, item) {
            return (_jsx(Space.Compact, { children: _jsx(Popconfirm, { title: "Are you sure you want to delete this organization?", onConfirm: function () { return onOrgDelete(item === null || item === void 0 ? void 0 : item.id); }, children: _jsx(Button, { icon: _jsx(DeleteOutlined, {}) }) }) }));
        },
        width: '20%'
    }
]; };
export var TeamOrganizationGroupsTable = function (_a) {
    var id = _a.id, filterValues = _a.filterValues, onOrganizationGroupDelete = _a.onOrganizationGroupDelete, containerRef = _a.containerRef;
    var data = useTeamOrganizationGroupsTable({
        filterValues: filterValues,
        id: id,
        containerRef: containerRef
    }).data;
    var loading = data.loading, organizationGroups = data.organizationGroups, scrollLoading = data.scrollLoading;
    var dimensions = useContainerDimensions(containerRef).dimensions;
    return (_jsx(Table, { mixCellTestId: true, filterValues: filterValues, columns: columns(onOrganizationGroupDelete), loading: loading || scrollLoading, scroll: {
            y: getSecureTableHeight(dimensions.height - OFFSET)
        }, tableLayout: "fixed", dataSource: organizationGroups }));
};
